module.exports = __webpack_public_path__ + "static/media/bot.5818c3cb.png";